import { api } from '@creditsights/api-ui-web';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const fetchAnalysts = async () => {
  const { data: analysts } = await api.get('common/v1/analysts', { params: { skip: 0, take: 1000, displayOnTeamsPage: true } });
  return analysts.filter((analyst) => {
    for (const position of analyst.positions) {
      if (['Research', 'Management', 'News', 'Covenants'].indexOf(position.department) !== -1) {
        return true;
      }
    }

    return false;
  });
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const fetchAnalyst = async (id) => {
  const { data } = await api.get(`common/v1/analysts/${id}`);
  return data;
};
